import TradeLyftMark from "./TradeLyftMark";
import styles from "./Brand.module.css";

const VARIANT_PRESETS = {
  page: {
    size: 72,
    showTile: false,
    inheritStroke: false,
    defaultCaption: "",
    className: styles.loaderPage,
    captionClass: styles.loaderCaption,
  },
  block: {
    size: 48,
    showTile: true,
    inheritStroke: false,
    defaultCaption: "Loading…",
    className: styles.loaderBlock,
    captionClass: styles.loaderCaptionMuted,
  },
  overlay: {
    size: 44,
    showTile: true,
    inheritStroke: false,
    defaultCaption: "Loading…",
    className: styles.loaderOverlay,
    captionClass: styles.loaderCaptionMuted,
  },
  inline: {
    size: 22,
    showTile: true,
    inheritStroke: false,
    defaultCaption: "Loading…",
    className: styles.loaderInline,
    captionClass: styles.loaderCaptionMuted,
  },
  row: {
    size: 22,
    showTile: true,
    inheritStroke: false,
    defaultCaption: "Loading…",
    className: styles.loaderRow,
    captionClass: styles.loaderCaptionMuted,
  },
  icon: {
    size: 18,
    showTile: false,
    inheritStroke: true,
    defaultCaption: "",
    className: styles.loaderIcon,
    captionClass: styles.loaderCaptionMuted,
  },
};

const TONE_PRESETS = {
  brand: { showTile: false, inheritStroke: false },
  surface: { showTile: true, inheritStroke: false },
  current: { showTile: false, inheritStroke: true },
};

function BrandLoader({
  variant = "page",
  caption,
  size,
  tone,
  className,
}) {
  const preset = VARIANT_PRESETS[variant] ?? VARIANT_PRESETS.page;
  const tonePreset = tone ? TONE_PRESETS[tone] : null;
  const showTile = tonePreset ? tonePreset.showTile : preset.showTile;
  const inheritStroke = tonePreset ? tonePreset.inheritStroke : preset.inheritStroke;
  const resolvedCaption = caption === undefined ? preset.defaultCaption : caption;
  const label = resolvedCaption || "Loading";

  return (
    <div
      className={[styles.loader, preset.className, className].filter(Boolean).join(" ")}
      role="status"
      aria-live="polite"
      aria-label={label}
    >
      <TradeLyftMark
        size={size ?? preset.size}
        animated
        showTile={showTile}
        inheritStroke={inheritStroke}
      />
      {resolvedCaption ? (
        <p className={preset.captionClass}>{resolvedCaption}</p>
      ) : null}
    </div>
  );
}

export default BrandLoader;
